import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import logo from '../assets/logo/logo.png';

// 平滑滚动到指定元素
const scrollToElement = (elementId: string) => {
  // 使用setTimeout确保DOM完全渲染
  setTimeout(() => {
    const element = document.getElementById(elementId);
    if (element) {
      // 获取Header的高度，用于计算偏移量
      const header = document.querySelector('.header') as HTMLElement;
      const headerHeight = header ? header.offsetHeight : 0;
      
      // 计算目标位置，考虑Header的高度
      const elementPosition = element.offsetTop - headerHeight - 20; // 额外20px的间距
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  }, 100);
};

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = (): void => {
    setIsMenuOpen(!isMenuOpen);
  };

  // 处理导航点击
  const handleNavClick = (elementId: string) => {
    if (location.pathname === '/') {
      // 如果在首页，执行平滑滚动
      scrollToElement(elementId);
    } else {
      // 如果不在首页，先跳转到首页，然后滚动到对应模块
      navigate('/', { state: { scrollTo: elementId } });
    }
  };

  return (
    <header className="header">
      <div className="top-bar">
        <div className="top-bar-segment red"></div>
        <div className="top-bar-segment orange"></div>
        <div className="top-bar-segment yellow"></div>
      </div>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <img src={logo} alt="解郁丸Logo" />
          </div>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li><a href="#carousel" onClick={(e) => { e.preventDefault(); handleNavClick('carousel'); }} className="nav-link-active">明星产品</a></li>
              <li><a href="#product-intro" onClick={(e) => { e.preventDefault(); handleNavClick('product-intro'); }}>产品介绍</a></li>
              <li><a href="#applicable-people" onClick={(e) => { e.preventDefault(); handleNavClick('applicable-people'); }}>适用人群</a></li>
              <li><a href="#product-center" onClick={(e) => { e.preventDefault(); handleNavClick('product-center'); }}>产品中心</a></li>
              <li><a href="#news" onClick={(e) => { e.preventDefault(); handleNavClick('news'); }}>新闻动态</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('contact'); }}>联系我们</a></li>
            </ul>
          </nav>

          <div className="mobile-menu-btn" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 